import type { AnnotationInfoT } from './annotation-timeline-v2/types';
export const getBasePayloadFromAnnotation = (annotationId: string, annotation: AnnotationInfoT, frame?: number) => ({
  objectType: annotation.annotationType,
  label: annotation.annotationLabel.title,
  objectId: annotationId,
  frame
});